import axios from 'axios'

export const postXenditPayment = async (payload) => {
  const { data: response } = await axios.post(`https://api.xendit.co/callback_virtual_accounts/external_id=${payload.ref_id}/simulate_payment`, 
    payload.body, {
    auth: {
      username: window.REACT_APP_XENDIT_USERNAME,
      password: ''
    }}
  )
  return response
}